// Kampanya Oluşturucu (Meta): reklamın hangi Facebook sayfasıyla yayınlanacağını müşteri bazlı seçtirir.
// Seçim müşteriye kaydedilir (PUT /campaigns/meta/page); tek sayfa varsa otomatik seçilir.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { T } from './poyais-ui/theme';
import { useLang, addTranslations } from './i18n';

addTranslations({
  'Facebook Sayfası': 'Facebook Page',
  'Reklam bu sayfa adına yayınlanır. Seçim bu müşteri için kaydedilir.': 'Ads run on behalf of this page. Your choice is saved for this client.',
  'Sayfa seç…': 'Choose a page…',
  'Bu reklam hesabıyla reklam verilebilen sayfa bulunamadı.': 'No page available to this ad account.',
});

export default function MetaPageSelect({ clientId, value, onChange }: { clientId: number; value: string; onChange: (id: string) => void }) {
  const { t } = useLang();
  const [pages, setPages] = useState<{ id: string; name: string }[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    axios.get(`/api/v1/campaigns/meta/pages?client_id=${clientId}`)
      .then(r => { if (!alive) return; setPages(r.data.pages || []); if (!value && r.data.selected) onChange(r.data.selected); })
      .catch(e => alive && setErr(e?.response?.data?.detail || ''))
      .finally(() => alive && setLoaded(true));
    return () => { alive = false; };
  }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = async (id: string) => {
    onChange(id);
    if (!id) return;
    try { await axios.put('/api/v1/campaigns/meta/page', { client_id: clientId, page_id: id }); setErr(''); }
    catch (e: any) { setErr(e?.response?.data?.detail || ''); }
  };

  if (loaded && !pages.length && !err) return <div style={{ fontSize: 11.5, color: T.redText }}>{t('Bu reklam hesabıyla reklam verilebilen sayfa bulunamadı.')}</div>;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label style={{ fontSize: 11, fontWeight: 700, color: T.textMidAlt }}>{t('Facebook Sayfası')}</label>
      <select value={value} onChange={e => pick(e.target.value)}
        style={{ padding: '10px 12px', borderRadius: 10, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontFamily: 'inherit', fontSize: 13 }}>
        <option value="">{t('Sayfa seç…')}</option>
        {pages.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
      <div style={{ fontSize: 11, color: err ? T.redText : T.textDim }}>{err || t('Reklam bu sayfa adına yayınlanır. Seçim bu müşteri için kaydedilir.')}</div>
    </div>
  );
}
